<template>
   <a-menu
      v-model="isOpen"
      :close-on-content-click="false"
      offset-y
      :z-index="99"
    >
      <template v-slot:activator="{ on, attrs }">
            <a-btn
              small
              v-bind="attrs"
              v-on="on"
              text
              color="white"
            >
              {{ $t('search.lblColumn') }}
              <v-icon size="22" v-if="!isOpen">mdi-chevron-down</v-icon>
              <v-icon size="22" v-else>mdi-chevron-up</v-icon>
            </a-btn>
      </template>
      <v-list id="filterListId" dense style="padding: 0" :min-width="240">
        <v-list-item-group
          v-model="selectedHeaders"
          multiple
          mandatory
          active-class=""
        >
          <template v-for="(item, index) in headers">
            <v-list-item
              :key="index"
              :value="item.value"
            >
              <template v-slot:default="{ active }">
                <v-list-item-action class="mr-2">
                  <v-checkbox dense :input-value="item.value === 'fileName' ? true : active" :readonly="item.value === 'fileName'"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                   {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
    </a-menu>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  name: "DocumentHeaderFilter",
  data() {
    return {
      isOpen: false,
      selectedHeaderItems: [],
    };
  },
  created() {
    this.loadFromLocalStorage();
  },
  watch: {
  },
  mounted(){

  },
  computed: {
    ...mapState({
      documentSearchHeaders: (state) => state.search.documentSearchHeaders,
    }),
    headers(){
      return [
        {
          value: 'fileName',
          text: this.$t("search.fileName")
        },
        {
          value: "agendaid",
          text: this.$t("search.agendaName"),
        },
        {
          value: "meetingid",
          text: this.$t("search.meetingName"),
        },
        {
          value: "directoryid",
          text: this.$t("search.directoryName"),
        },
        {
          value: "metadata_storage_last_modified",
          text: this.$t("search.modifiedDate"),
        },
        {
          value: "metadata_author",
          text: this.$t("search.modifiedBy"),
        },
        {
          value: "username",
          text: this.$t("search.uploader"),
        },
      ]
    },
    selectedHeaders: {
      get() {
        return this.selectedHeaderItems;
      },
      set(value) {
        // Ensure `fileName` is always selected
        if (!value.includes("fileName")) {
            value = ["fileName", ...value];
        }
        this.selectedHeaderItems = value;
        this.saveToLocalStorage(value);
        this.setDocumentHeaders(value);
      },
    },
    tenantId() {
      return sessionStorage.getItem("tenantId");
    },
   
  },
  methods: {
    ...mapMutations({
      setDocumentHeaders: "search/SET_DOCUMENT_HEADERS",
    }),
    loadFromLocalStorage() {
    const storageKey = `document_search_header#${this.tenantId}`;
    const headers = this.headers.map(header => header.value);
    const storedHeaders = JSON.parse(localStorage.getItem(storageKey) || "[]");
    if (Array.isArray(storedHeaders) && storedHeaders.length) {
      // Ensure selectedHeaderItems reference objects from this.headers
      this.selectedHeaderItems = storedHeaders.filter(header => headers.includes(header)); // Remove undefined values if no match is found
    } else {
      this.selectedHeaderItems = this.headers.map(header => header.value); // Default to all headers if none are stored
    }
    this.setDocumentHeaders(this.selectedHeaderItems);
  },
  saveToLocalStorage(selectedHeaders) {
      const storageKey = `document_search_header#${this.tenantId}`;
      try {
        localStorage.setItem(storageKey, JSON.stringify([...new Set(selectedHeaders)]));
      } catch (error) {
        console.error("Error saving headers to localStorage:", error);
      }
    },
  }
};
</script>
